//#region types
import { BoardMemberDisplayComponentProps } from "models/propTypes/boardMemberPropTypes";
//#endregion
//#region components
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const BoardMemberDisplayComponent: React.FC<BoardMemberDisplayComponentProps> = (props) => {
  const { name, socialSecurityNumber, roles } = props.value ?? {};

  const roleList = Array.isArray(roles) ? roles.map((r) => r.roleName).filter(Boolean) : [];

  return (
    <Grid container direction="column" rowGap={0} className={cssExports.boardMemberDisplay}>
      <Grid item>
        <Typography className={cssExports.boardMemberName}>{name || ""}</Typography>
      </Grid>
      <Grid item>
        <Typography className={cssExports.boardMemberSocialSecurityNumber}>{socialSecurityNumber || ""}</Typography>
      </Grid>
      <Grid item>
        <Typography className={cssExports.boardMemberRoles}>{roleList.join(", ") || ""}</Typography>
      </Grid>
    </Grid>
  );
};

export default BoardMemberDisplayComponent;
